import $ from "jquery";

const accordion = (accordionEl) => {
  accordionEl.off("click");
  accordionEl.on("click", () => toggleAccordion(accordionEl));
};

const toggleAccordion = (accordionEl) => {
  accordionEl.hasClass("active")
    ? accordionEl
        .removeClass("active")
        .one("transitionend", () =>
          accordionEl.children(".accordion__text").slideUp(300)
        )
    : accordionEl
        .children(".accordion__text")
        .slideDown(300, () => accordionEl.addClass("active"));
};

export const reloadScriptAccordion = () => {
  const $accordionEl = $(".accordion");
  $accordionEl.each(function () {
    accordion($(this));
    
  });
};
reloadScriptAccordion();

const accordionSubject = (accordionEl) => {
  accordionEl.off("click");
  accordionEl.on("click", () => toggleAccordionSubject(accordionEl));
};

const toggleAccordionSubject = (accordionEl) => {
  accordionEl.parent().hasClass("active")
    ? accordionEl.parent()
        .removeClass("active")
        .one("transitionend", () =>
          accordionEl.parent().children(".accordion-subject__text").slideUp(300)
        )
    : accordionEl.parent()
        .children(".accordion-subject__text")
        .slideDown(300, () => accordionEl.parent().addClass("active"));
};

export const reloadScriptAccordionSubject = () => {
  const $accordionEl = $(".accordion-subject__title");
  $accordionEl.each(function () {
    accordionSubject($(this));
    
  });
};
reloadScriptAccordionSubject();